import {Component, OnDestroy, OnInit} from '@angular/core';
import {IndividuService} from '@Common/core/services';
import {roles} from '../../../common/enum/roles';
import {SubSink} from '@Common/core/utils/subsink';

@Component({
  selector: 'p8-demat-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit, OnDestroy {
  urlApi = '/demat/manageroles/';
  urlApiIndividu = '/gestion_universite/individu/';

  isAdmin = false;
  isSuperGest = false;
  subSink = new SubSink();

  constructor(private individuService: IndividuService) {
  }

  ngOnInit() {
    this.subSink.sink = this.individuService.individu$.subscribe(_individu => {
      this.isSuperGest = this.individuService.hasRole(_individu, roles.superviseur);
      this.isAdmin = this.individuService.hasRole(_individu, roles.admin);
    });
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
